import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

interface StCommunityContainerProps {
  isDefaultApp?: boolean;
}

export const StCommunityWrapper = styled(Grid)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
}));

export const StCommunityContainer = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'isDefaultApp',
})<StCommunityContainerProps>(({ theme, isDefaultApp }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'center',
  padding: '4rem 8rem',
  color: theme.palette.neutral8.main,

  [theme.breakpoints.down('lg')]: {
    padding: '3rem 4rem',
  },
  [theme.breakpoints.down('sm')]: {
    padding: isDefaultApp ? '2rem 1.5rem' : '2rem 2rem',
  },
  [theme.breakpoints.up('xl')]: {
    width: '1300px',
    margin: '0 auto !important',
    padding: isDefaultApp ? '3rem 2rem' : '4rem 2rem',
  },
}));
